<template>
  <div class="mb-5">
    <h4 class="text-capitalize font-weight-bold py-2">
      {{ title }}
    </h4>
    <b-progress
      :value="currentStep"
      :max="maxSteps"
    />
  </div>
</template>

<script>
export default {
  name: 'StepProgressBar',
  props: {
    title: {
      type: String,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    maxSteps: {
      type: Number,
      required: true
    },
  },
}
</script>
